import { useCssModule, computed } from "vue";
import "./index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./index-BNd8MWnO.js";
import "./index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XIcon } from "./XIcon-U9bwokTN.js";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
function useInputProps() {
  const MESSAGE_TYPES = {
    error: "error",
    warning: "warning",
    success: "success",
    info: "info"
  };
  function createMessageProps2() {
    return {
      message: {
        type: String,
        default: ""
      },
      messageType: {
        type: String,
        default: MESSAGE_TYPES.error,
        validator: (type) => Object.values(MESSAGE_TYPES).includes(type)
      }
    };
  }
  function createAdditionalMessagesProp() {
    return {
      additionalMessages: {
        type: Array,
        default: () => []
      }
    };
  }
  function createLabelProps() {
    return {
      label: {
        type: String,
        default: ""
      },
      helpLink: {
        type: String,
        default: ""
      },
      helpTooltip: {
        type: String,
        default: ""
      }
    };
  }
  function createFormFieldProps() {
    return {
      focusable: {
        type: Boolean,
        default: true
      },
      grouped: {
        type: Boolean,
        default: false
      },
      flexible: {
        type: Boolean,
        default: false
      }
    };
  }
  function createInputProps({ placeholder = "" } = { placeholder: void 0 }) {
    return {
      value: {
        type: String,
        default: ""
      },
      name: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: placeholder
      }
    };
  }
  function createRequiredProp() {
    return {
      required: {
        type: Boolean,
        default: false
      }
    };
  }
  return {
    MESSAGE_TYPES,
    createMessageProps: createMessageProps2,
    createAdditionalMessagesProp,
    createLabelProps,
    createFormFieldProps,
    createInputProps,
    createRequiredProp
  };
}
const message = "_message_1mk9j_1";
const error = "_error_1mk9j_6";
const info = "_info_1mk9j_9";
const warning = "_warning_1mk9j_12";
const success = "_success_1mk9j_15";
const messageText = "_messageText_1mk9j_18";
const style0 = {
  message,
  error,
  info,
  warning,
  success,
  messageText
};
const { createMessageProps } = useInputProps();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "SingleMessage",
  components: {
    XIcon
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...createMessageProps(),
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const messageIcons = {
      error: "xmark-large",
      warning: "triangle-exclamation",
      success: "circle-check",
      info: "circle-exclamation"
    };
    const $style = useCssModule();
    const { formatTestId } = setupTestId(props);
    const messageTypeClass = computed(() => ({
      [$style[props.messageType]]: true
    }));
    const messageIconName = computed(() => messageIcons[props.messageType]);
    return { __sfc: true, createMessageProps, createTestIdProp, setupTestId, props, messageIcons, $style, formatTestId, messageTypeClass, messageIconName, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.message, expression: "message" }], class: [_setup.$style.message, _setup.messageTypeClass], attrs: { "aria-live": "polite", "data-testid": _setup.formatTestId() } }, [_c(_setup.XIcon, { attrs: { "icon": _setup.messageIconName, "fixed-width": "", "data-testid": _setup.formatTestId("icon") } }), _c("small", { class: _setup.$style.messageText }, [_vm._v(" " + _vm._s(_vm.message) + " ")])], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const SingleMessage = __component__.exports;
export {
  SingleMessage as S,
  useInputProps as u
};
